export const CONFIRMATION_TEST_IDS = {
  root: 'confirmation-page',
  shimmer: 'shimmer',
  status: 'status',
  firstName: 'first-name',
  cardBrandIcon: 'card-brand-icon',
  cardBrandName: 'card-brand-name',
  lastFour: 'last-four',
  achLastFour: 'ach-last-four',
  total: 'total',
  subtotal: 'subtotal',
  surcharge: 'surcharge',
  tip: 'tip-amount',
  transactionId: 'transaction-id',
  taxAmount: 'tax-amount',
  orderNote: 'order-note',
  paymentSource: 'payment-source',
};
